<script>
	import { createEventDispatcher } from "svelte";
	import Trash from "../icons/Trash.svelte";

	export let title = "Delete";
	export let style = false;
	export let disabled = false;

	const dispatcher = createEventDispatcher();

	const deleteItem = () => {
		dispatcher("delete");
	};

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button class={className} {style} on:click|preventDefault={deleteItem} {title} {disabled} type="submit">
	<Trash />
</button>

<style>
	button {
		color: var(--color-body);
		background-color: transparent;
		border: none;
		padding: 0;
		font-size: 18px;
		cursor: pointer;
	}

	.fa-trash {
		color: var(--color-primary);
	}
</style>
